module.exports = "<div class=\"m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-container m-container--responsive m-container--xxl m-container--full-height\">\r\n\t<div class=\"m-grid__item m-grid__item--fluid m-wrapper\">\r\n\t\t<router-outlet></router-outlet>\r\n\t</div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/pages/loader-enabled-enabled-type-spinner-message/loader-enabled-enabled-type-spinner-message.component.html
// module id = ./src/app/theme/pages/loader-enabled-enabled-type-spinner-message/loader-enabled-enabled-type-spinner-message.component.html
// module chunks = main